import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router'; // Added RouterLink imports
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu'; // Moved from Sidebar
import { NzIconModule } from 'ng-zorro-antd/icon'; // Moved from Sidebar
import { TopbarComponent } from '../topbar/topbar.component';
import { ChangePasswordModalComponent } from '../../components/change-password/change-password-modal.component';
import { AuthService } from '../../services/auth/auth.service';
import { PermissionEnum, UserDto, UserStatusEnum } from '../../dto';

@Component({
    selector: 'app-full-layout',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        RouterLink,
        TopbarComponent,
        ChangePasswordModalComponent,
        NzLayoutModule,
        NzMenuModule, // Add this
        NzIconModule  // Add this
    ],
    templateUrl: './full-layout.component.html',
    styleUrl: './full-layout.component.scss'
})
export class FullLayoutComponent implements AfterViewInit {
    user!: UserDto | undefined;
    isCollapsed = false; // State for the sidebar

    @ViewChild(ChangePasswordModalComponent) changePasswordModal!: ChangePasswordModalComponent;

    PermissionEnum = PermissionEnum;

    constructor(public authService: AuthService) { }

    ngAfterViewInit(): void {
        this.user = this.authService.getUser();
        if (this.user?.tempPassword) {
            this.changePasswordModal.open(this.user);
        }
    }
}